import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";
import Tables from "../../Table.js";

const enterpriselevel = require("../../../assets/icons-pack//3.1 Elastic Computer Server/ic_01_enterpriselevel.svg");
const highavailible = require("../../../assets/icons-pack/3.1 Elastic Computer Server/ic_02_highavailible.svg");
const flexiblecloudservice = require("../../../assets/icons-pack/3.1 Elastic Computer Server/ic_04_flexiblecloudservice.svg");
const disasterrecovery = require("../../../assets/icons-pack/3.1 Elastic Computer Server/ic_05_disasterrecovery.svg");

const ECS = () => {
    const heading = "Elastic Compute Server (ECS) ";
    const details = `Create, develop and launch your business applications on a flexible, secure and on-demand compute resources on the cloud.`;

    const overview = [
        `Elastic Compute Server (ECS) will provide you on-the-fly scalability for your business applications through a simple interface. Using ECS would save you the time in spinning up the required computing resources or your applications.`
    ];

    const advantages = [
        [
            "Enterprise Level Security ",
            "DETASAD ECS is designed to meet the highly intensive security metrics and compliances. ECS security features protect your compute resources from the most advanced security breaches and threats.",
            enterpriselevel
        ],
        [
            "Highly Available",
            "Your business applications are protected against hardware failure through high available design protecting your workload from partial or major failures.",
            highavailible
        ],
        [
            "Elastic and Flexible",
            "Choose according to your business needs from a variety of flavors and images ready to be deployed. Make your own scaling rules to ensure that your business has the exact resources as required. Scale up and down, east and west easily and rapidly.",
            flexiblecloudservice
        ],
        [
            "Disaster Recovery ",
            "Extend your business continuity across multiple regions inside KSA through DETASAD ECS disaster recovery solutions on a redundant infrastructure design.",
            disasterrecovery
        ]
    ];

    const functions = [
        [
            `Server Management`,
            [
                `Set up server groups to organize, administer and manage multiple servers as a single unit. Server Snapshots can be scheduled, which allow a quick restore.`
            ]
        ],
        [
            `Customization`,
            [
                `Create your own baseline OS templates for cloud servers, including customized builds, software packages, security programs or other components.`
            ]
        ],
        [
            `High Availability and Performance`,
            [
                `DETASAD ECS infrastructure is highly optimized, ensuring high performance. ECS includes powerful features such as Dedicated Load Balancing, Autoscaling and built-in redundancy features that improves uptime.`
            ]
        ]
    ];

    const ecsflavours = [
        `Build cloud servers to meet your specific requirements, choose from rich pre-configured options. Our servers are consumed and billed on an hourly basis — no contract required. You can scale up or down as best makes sense for your development, testing or production requirements.`
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav
                overview={overview}
                advantages={advantages}
                functions={functions}
                ecsflavours={ecsflavours}
                Tables={Tables}
            />
            <Footer />
        </div>
    );
};

export default ECS;
